import { combineReducers } from '@reduxjs/toolkit';

import { authorization } from '@/api/authorization';

import { NameSpace } from '@/constant/store';

import { api } from '../api';

import { appProcess } from './app-process/app-process';
import { userProcess } from './user-process/user-process';

export const rootReducer = combineReducers({
	[NameSpace.process]: appProcess.reducer,
	[NameSpace.user]: userProcess.reducer,
	[NameSpace.api]: api.reducer,
	[NameSpace.authorization]: authorization.reducer,
});
